// @flow
// @jsx h

declare var STRIPE_API_KEY: string;

// External librairies
import { h, Component } from "preact";

import { useState, useEffect } from 'preact/hooks';

import  Loading  from "elc-loading";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

// Components
//import StripePaymentForm from "./stripe-payment-form";
import PaymentForm from './payment-form/PaymentForm';

// API
import { StripeService } from "elc-internal-api";

const stripePromise = loadStripe(STRIPE_API_KEY);

const appearance = {
  //theme: 'flat', // Utilisation du thème "flat"
  variables: {

    colorBackground: '#f7f7f7',
    colorTextPlaceholder : '#aeb3b9', //styles.placeholderColor
    colorText: '#808c9c', //styles.textColor
    colorDanger: '#ff0000',

    borderRadius: '0',

    fontWeightBold: '600',
    fontSizeBase: '15px',
    lineHeight: '18px',
  },
  rules: {
    '.Label': {
      color: '#aeb3b9',
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight:'1.125rem'
    },
    '.Input': {
      borderColor: '#aeb3b9',
      color: '#808c9c',
      fontWeight: 'bold',
    },
    '.Field' : {
      marginBottom: '4px',
    }
  },
};

class StripePayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clientSecret : null,
      pi : null,
      options: {
        clientSecret: null,
        locale : props.locale,
        paymentMethodCreation: 'manual',
        appearance
      }
    }
  }

  componentDidMount() {
    // console.log("this.props.callbackStripe",  this.props.callbackStripe);
    // console.log("this.props.locale",  this.props.locale);
  // Crée un PaymentIntent lors du chargement du composant
  StripeService.createPaymentIntent(
    {
      order: this.props.order,
      paymentMethod : this.props.paymentMethod,
      locale: this.props.locale,
      callbackStripe : this.props.callbackStripe
    },
    (res, err) => {
      if (err) {
        console.error(err.error);
        return;
      } else {
      // console.log('createPaymentIntent res:', res);
      // console.log('props.locale:', this.props.locale);
      this.setState(prevState => ({
        options: {
          ...prevState.options,
          clientSecret: res.client_secret
        }
      }));
      this.setState({clientSecret: res.client_secret});
      this.setState({pi: res.pi});
      }
    }
  );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.locale !== this.props.locale) {
      this.setState(prevState => ({
        options: {
          ...prevState.options,
          locale: nextProps.locale
        }
      }));
    }
  }


  render({
    hash,
    config,
    currency,
    locale,
    order,
    paymentMethod,
    setPaymentMethod,
    removeBeforeUnloadListener,
    callbackStripe,
    urlToShop,
    checkSession,
    sessionValid
  },{
    clientSecret,
    pi,
    options
  }) {
    // console.log('this props', this.props)
    // console.log('arguments', arguments)
    // console.log('Current option state:', this.state.options)
    return (
      <div>
      {clientSecret ?
        <Elements stripe={stripePromise} options={options} >
          <PaymentForm
          order={order}
          paymentMethod={paymentMethod}
          setPaymentMethod={setPaymentMethod}
          locale={locale}
          callbackStripe={callbackStripe}
          pi={pi}
          checkSession={checkSession}
          sessionValid={sessionValid}
           />
        </Elements>
        : <Loading />}
      </div>
    // <Elements stripe={stripePromise} locale={locale}>
    //   <StripePaymentForm
    //         hash={hash}
    //         config={config}
    //         currency={currency}
    //         locale={locale}
    //         order={order}
    //         paymentMethod={paymentMethod}
    //         setPaymentMethod={setPaymentMethod}
    //         removeBeforeUnloadListener={removeBeforeUnloadListener}
    //         callbackStripe={callbackStripe}
    //         urlToShop={urlToShop}
    //       />
    //   </Elements>
    );
  }
}

export default StripePayment;
